import React from 'react';
import { Link } from '@reach/router';
import { canBulkReassignPageOwner } from '../../utilities/permissionsUtilities';
import {
    EVERYTHING, SUBCATEGORIES, PAGES, QUESTIONS, LINKS, REQUESTS, DOCUMENTS,
} from '../../utilities/CONSTANTS';
import { pluralText } from '../../utilities/wordUtilities';
import ArchiveItemsButton from './ArchiveItemsButton';
import MoveItemsButton from './MoveItemsButton';
import ChangeOwnerButton from './ChangeOwnerButton';

const CategoryInfo = ({
    everythingTabNavCount,
    subcategoryTabNavCount,
    pagesTabNavCount,
    linksTabNavCount,
    documentsTabNavCount,
    requestsTabNavCount,
    moveMode,
    totalPageCount,
    totalFolderCount,
    totalSuggestionCount,
    totalExternalResourceCount,
    totalQuestionCount,
    totalDocumentCount,
    selectedPageCount,
    selectedFoldersCount,
    selectedSuggestionCount,
    selectedExternalResourceCount,
    selectedQuestionsCount,
    selectedDocumentsCount,
    selectAll,
    moveItems,
    archiveItems,
    changeOwner,
    count,
    sortMode,
    disableSortMode,
    selectedTab,
    handleSetSelectedTab,
    questionsCount,
}) => {
    if (!moveMode) {
        return (
            <div>
                <Link to={window.currentUrl}>
                    <button
                        className={`tab ${selectedTab === EVERYTHING ? 'selected' : 'blue'}`}
                        onMouseDown={() => handleSetSelectedTab(EVERYTHING)}
                    >
                    Everything
                        <span className="tab-nav-count">
                            {everythingTabNavCount}
                        </span>
                    </button>
                </Link>
                <Link to={`${window.currentUrl}/${SUBCATEGORIES}`}>
                    <button
                        className={`tab ${selectedTab === SUBCATEGORIES ? 'selected' : 'blue'}`}
                        onMouseDown={() => handleSetSelectedTab(SUBCATEGORIES)}
                    >
                    Subcategories
                        <span className="tab-nav-count">
                            {subcategoryTabNavCount}
                        </span>
                    </button>
                </Link>
                <Link to={`${window.currentUrl}/${PAGES}`}>
                    <button
                        className={`tab ${selectedTab === PAGES ? 'selected' : 'blue'}`}
                        onMouseDown={() => handleSetSelectedTab(PAGES)}
                    >
                    Pages
                        <span className="tab-nav-count">
                            {pagesTabNavCount}
                        </span>
                    </button>
                </Link>
                {window.loggedIn
                && (
                    <Link to={`${window.currentUrl}/${QUESTIONS}`}>
                        <button
                            className={`tab ${selectedTab === QUESTIONS ? 'selected' : 'blue'}`}
                            onMouseDown={() => handleSetSelectedTab(QUESTIONS)}
                        >
                    Questions
                            <span className="tab-nav-count">
                                {questionsCount}
                            </span>
                        </button>
                    </Link>
                )}
                <Link to={`${window.currentUrl}/${LINKS}`}>
                    <button
                        className={`tab ${selectedTab === LINKS ? 'selected' : 'blue'}`}
                        onMouseDown={() => handleSetSelectedTab(LINKS)}
                    >
                    Links
                        <span className="tab-nav-count">
                            {linksTabNavCount}
                        </span>
                    </button>
                </Link>
                <Link to={`${window.currentUrl}/${DOCUMENTS}`}>
                    <button
                        className={`tab ${selectedTab === DOCUMENTS ? 'selected' : 'blue'}`}
                        onMouseDown={() => handleSetSelectedTab(DOCUMENTS)}
                    >
                    Documents
                        <span className="tab-nav-count">
                            {documentsTabNavCount}
                        </span>
                    </button>
                </Link>
                <Link to={`${window.currentUrl}/${REQUESTS}`}>
                    <button
                        className={`tab ${selectedTab === REQUESTS ? 'selected' : 'blue'}`}
                        onMouseDown={() => handleSetSelectedTab(REQUESTS)}
                    >
                    Requests
                        <span className="tab-nav-count">
                            {requestsTabNavCount}
                        </span>
                    </button>
                </Link>
                {sortMode
                    && (
                        <button className="tab" onMouseDown={disableSortMode}>
                        Clear sort
                        </button>
                    )}
            </div>
        );
    }
    if (!selectedPageCount && !selectedFoldersCount && !selectedSuggestionCount && !selectedExternalResourceCount && !selectedQuestionsCount && !selectedDocumentsCount) {
        return (
            <label className="ml2">
                <input type="checkbox" className="bulk-action-checkbox" onChange={selectAll} />
                { pluralText(totalPageCount, 'page', true) }
                {' '}
                { pluralText(totalSuggestionCount, 'page request', true) }
                {' '}
                { pluralText(totalExternalResourceCount, 'link', true) }
                {' '}
                { pluralText(totalQuestionCount, 'question', true) }
                {' '}
                { pluralText(totalDocumentCount, 'document', true) }
                {' '}
                { pluralText(totalFolderCount, 'subcategory', true) }
            </label>
        );
    }

    const selectedItemCount = selectedPageCount + selectedSuggestionCount + selectedExternalResourceCount + selectedQuestionsCount + selectedDocumentsCount;

    const selectedText = `${pluralText(selectedItemCount, 'item', true)} ${
        pluralText(selectedFoldersCount, 'subcategory', true)
    }${selectedFoldersCount ? ' (and contained items) ' : ' '
    }selected`;

    const noPagesSelected = selectedPageCount < 1;

    return (
        <label className="ml2">
            <input type="checkbox" className="bulk-action-checkbox" onChange={selectAll} />
            {selectedText}
            <MoveItemsButton moveItems={moveItems} />
            <ArchiveItemsButton archiveItems={archiveItems} />
            {canBulkReassignPageOwner && (
                <ChangeOwnerButton
                    changeOwner={changeOwner}
                    disabled={noPagesSelected}
                />
            )}
        </label>
    );
};

export default CategoryInfo;
